export const MAILTO = "mailto:";
export const SUBJECT = "subject=";
export const SUBJECT_TEXT = "Nachforderung%20Informationen";
export const MAILBODY = "body=";
export const QUERYSTART = "?";
export const QUERYCONCAT = "&";
export const QUERYSPACE = "%20";
